import React, { useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    Box,
    Button,
    Menu,
    MenuItem,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const BulkEditionMenu = ({
    items,
    prefix,
    selectedBulkOption,
    setSelectionModel,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const label = () => {
        if (selectedBulkOption) return selectedBulkOption;
        return prefix;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: { xs: 'start', md: 'center' },
                gap: 1,
            }}
        >
            <>
                <Button
                    color="secondary"
                    endIcon={<KeyboardArrowDownIcon />}
                    fullWidth
                    onClick={handleClick}
                    variant="outlined"
                >
                    <Typography
                        component="span"
                        fontWeight="bold"
                        noWrap
                        sx={{
                            overflow: 'hidden',
                            width: 'calc(100% - 16px)',
                            textAlign: 'left',
                            textOverflow: 'ellipsis',
                            textTransform: 'initial',
                        }}
                        variant="body2"
                    >
                        {label()}
                    </Typography>
                </Button>

                <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                    {items.map(({ handleClick, label, visible }, index) =>
                        visible ? (
                            <MenuItem
                                key={`bulk-option-${index}`}
                                onClick={() => {
                                    handleClick();
                                    handleClose();
                                }}
                            >
                                <Typography variant="body2" color="#848bab">
                                    {label}
                                </Typography>
                            </MenuItem>
                        ) : null,
                    )}
                </Menu>
            </>

            <Button
                color="secondary"
                onClick={() => setSelectionModel([])}
                variant="outlined"
            >
                {t('Cancel')}
            </Button>
        </Box>
    );
};

BulkEditionMenu.propTypes = {
    items: PropTypes.array,
    prefix: PropTypes.string,
    selectedBulkOption: PropTypes.string,
    setSelectionModel: PropTypes.func,
};

export default BulkEditionMenu;
